"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadingMode = void 0;

/*
 * Enum for video loading mode
 * @readonly
 * @enum {number}
 */
var LoadingMode = {
  LOW: 1,
  // only one main video
  MED: 2,
  // all sub videos, one main video
  HIGH: 3,
  // default, all videos
  SUPER_HIGH: 4 // default, all videos

};
exports.LoadingMode = LoadingMode;